// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3atMm","icon":"SortAdornment_icon__Yy_hL","up":"SortAdornment_up__1xuIH","down":"SortAdornment_down__3mceR","active":"SortAdornment_active__2v08H"};